// QuestEditorのmockにアクセス可能なドメイン・メールアドレス
export const QuestEditorAllowedDomain = ["r-n-i.jp", "asianbridge.co.jp"];
export const QuestEditorAllowedEmail = ["h.yamamoto.se@gmail.com"];

export const PromotionType = {
  QA: "qa",
  BYOUSOKU_QA: "byousoku_qa",
} as const;

export type PromotionTypeValue =
  (typeof PromotionType)[keyof typeof PromotionType];

export const promotionTypes: PromotionTypeValue[] = [
  PromotionType.QA,
  PromotionType.BYOUSOKU_QA,
];

export const PromotionStatus = {
  CREATED: "created",
  REQUEST_WAITING: "request_waiting",
  WAITING: "waiting",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  SUSPENDED: "suspended",
  CLOSED: "closed",
} as const;

export type PromotionStatusValue =
  (typeof PromotionStatus)[keyof typeof PromotionStatus];

export const promotionStatuses: PromotionStatusValue[] = [
  PromotionStatus.CREATED,
  PromotionStatus.REQUEST_WAITING,
  PromotionStatus.WAITING,
  PromotionStatus.IN_PROGRESS,
  PromotionStatus.DONE,
  PromotionStatus.SUSPENDED,
  PromotionStatus.CLOSED,
];

export const QuestStatus = {
  CREATED: "created",
  REQUEST_WAITING: "request_waiting",
  WAITING: "waiting",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  SUSPENDED: "suspended",
  CLOSED: "closed",
} as const;

export type QuestStatusValue = (typeof QuestStatus)[keyof typeof QuestStatus];

export const questStatuses: QuestStatusValue[] = [
  QuestStatus.CREATED,
  QuestStatus.REQUEST_WAITING,
  QuestStatus.WAITING,
  QuestStatus.IN_PROGRESS,
  QuestStatus.DONE,
  QuestStatus.SUSPENDED,
  QuestStatus.CLOSED,
];

export const QuestCreateStatus = {
  WAITING: "waiting",
  DONE: "done",
} as const;

export type QuestCreateStatusValue =
  (typeof QuestCreateStatus)[keyof typeof QuestCreateStatus];

export const questCreateStatuses: QuestCreateStatusValue[] = [
  QuestCreateStatus.WAITING,
  QuestCreateStatus.DONE,
];

export const OwnerType = {
  OWN: "own",
  OTHER: "other",
} as const;

export type OwnerTypeValue = (typeof OwnerType)[keyof typeof OwnerType];

export const ownerTypes: OwnerTypeValue[] = [OwnerType.OWN, OwnerType.OTHER];

export const AuditLogOperation = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  APPROVE: "approve",
  REJECT: "reject",
  START: "start",
  STOP: "stop",
  EXPORT: "export",
} as const;

export type AuditLogOperationValue =
  (typeof AuditLogOperation)[keyof typeof AuditLogOperation];

export const auditLogOperations: AuditLogOperationValue[] = [
  AuditLogOperation.CREATE,
  AuditLogOperation.UPDATE,
  AuditLogOperation.DELETE,
  AuditLogOperation.APPROVE,
  AuditLogOperation.REJECT,
  AuditLogOperation.START,
  AuditLogOperation.STOP,
  AuditLogOperation.EXPORT,
];

export const Gender = {
  MALE: "male",
  FEMALE: "female",
} as const;

export type GenderValue = (typeof Gender)[keyof typeof Gender];
export type GenderEnum = GenderValue;

export const genders: GenderEnum[] = [Gender.MALE, Gender.FEMALE];

export const MaritalStatus = {
  SINGLE: "single",
  MARRIED: "married",
} as const;

export type MaritalStatusValue =
  (typeof MaritalStatus)[keyof typeof MaritalStatus];
export type MaritalStatusEnum = MaritalStatusValue;

export const maritalStatuses: MaritalStatusEnum[] = [
  MaritalStatus.SINGLE,
  MaritalStatus.MARRIED,
];

export const JoinCondition = {
  AND: "and",
  OR: "or",
} as const;

export type JoinConditionValue =
  (typeof JoinCondition)[keyof typeof JoinCondition];
export type JoinConditionEnum = JoinConditionValue;

export const joinConditions: JoinConditionEnum[] = [
  JoinCondition.AND,
  JoinCondition.OR,
];

export const ProfileType = {
  MARRIAGE: "marriage",
  OCCUPATION: "occupation",
  INDUSTRY: "industry",
  NUMBER_OF_PEOPLE: "number_of_people",
  NUMBER_OF_CHILDREN: "number_of_children",
} as const;

export type ProfileTypeValue = (typeof ProfileType)[keyof typeof ProfileType];

export const profileTypes: ProfileTypeValue[] = [
  ProfileType.MARRIAGE,
  ProfileType.OCCUPATION,
  ProfileType.INDUSTRY,
  ProfileType.NUMBER_OF_PEOPLE,
  ProfileType.NUMBER_OF_CHILDREN,
];

export const TemplateScope = {
  CREATOR: "creator",
  COMPANY: "company",
  PUBLIC: "public",
} as const;

export type TemplateScopeValue =
  (typeof TemplateScope)[keyof typeof TemplateScope];

export const templateScopes: TemplateScopeValue[] = [
  TemplateScope.CREATOR,
  TemplateScope.COMPANY,
  TemplateScope.PUBLIC,
];

export const LinkParam = {
  PLAYER_ID: "player_id",
} as const;

export type LinkParamValue = (typeof LinkParam)[keyof typeof LinkParam];

export const linkParams: LinkParamValue[] = [LinkParam.PLAYER_ID];

export const IncentiveType = {
  TAMARU: "tamaru",
  PRIZE: "prize",
} as const;

export type IncentiveTypeValue =
  (typeof IncentiveType)[keyof typeof IncentiveType];

export const incentiveTypes: IncentiveTypeValue[] = [
  IncentiveType.TAMARU,
  IncentiveType.PRIZE,
];

export const DayOfWeek = {
  SUNDAY: "sunday",
  MONDAY: "monday",
  TUESDAY: "tuesday",
  WEDNESDAY: "wednesday",
  THURSDAY: "thursday",
  FRIDAY: "friday",
  SATURDAY: "saturday",
} as const;

export type DayOfWeekValue = (typeof DayOfWeek)[keyof typeof DayOfWeek];

export const daysOfWeek: DayOfWeekValue[] = [
  DayOfWeek.SUNDAY,
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
];

// 配信分割数
export const DIVISION_COUNT = 36;

// 進捗通知設定の最大件数
export const PROGRESS_NOTIFICATION_MAX_COUNT = 5;
